export enum AdminRoutsParamsEnum {
  report = 'report',
  practice_export = 'practice_export',
  pharmacy_report = 'pharmacy_report',
  labs_report = 'labs_report',
}
